module.exports = __webpack_public_path__ + "static/logo-white-ef08b54a0d91307e86c8f1e4cf2d1f9c.svg";